package com.exura.ui

import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.div
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

object Dimens {
    // GENERICS:
    val spacingNone = 0.px
    val appViewHeight = 100.vh
    val appViewWidth = 100.vw
    val separatorWidthDefault = 1.px
    val brandingLogoDefaultHeight = 138.px
    val spinnerSizeDefault = 2.cssRem
    val mainIconSizeDefault = 4.cssRem
    val inlineTextRelGapSize = 0.5.em
    // LOG BOX
    val loggingBoxMaxWidth = 31.cssRem
    val loggingBoxMinHeight = 40.cssRem
    val loggingBoxLogoSize = 3.cssRem
    val loggingBoxBorderRadius = 1.cssRem
    val loggingBoxIndent = 2.cssRem
    val loggingBoxWrapping = 2.cssRem
    val loggingBoxContentGap = 1.cssRem
    val loggingBoxSpinnerSize = 3 * spinnerSizeDefault
    val loggingBoxInputsFontSize = 1.5.cssRem
    // ICONS & IMAGES:
    val iconRelSizeDefault = 1.2.em
    val iconTextRelGapSizeDefault = 0.5.em
    val imageSelectionDialogIndent = 1.cssRem
    val imageSelectionDialogWrapping = 0.5.cssRem
    val imageSelectionDialogGap = 0.25.cssRem
    // NAV:
    val navSectionHeaderFontSize = 1.1.cssRem
    val navSectionHeaderWrapping = 0.25.cssRem
    val navSectionSeparatorWidth = 2 * separatorWidthDefault

    val navElementFontSize = 1.cssRem
    val navElementIndent = 1.cssRem
    val navElementWrapping = 0.5.cssRem
    val navElementBorderRadius = navElementFontSize

    val navNavigationSectionsGap = 1.5.cssRem
    val navNavigationSectionsGapRolling = 2.cssRem
    val navNavigationElementContentSize = 10 * navElementFontSize
    val navNavigationIndent = 2.cssRem
    val navNavigationWrapping = 2.cssRem
    val navNavigationEntriesGap = 0.25.cssRem
    val navNavigationSeparatorWidth = 2 * separatorWidthDefault

    val navLogoHeight = 4.cssRem
    val navLogoBottomSpace = 2.cssRem
    // DIALOGS:
    val dialogBorderRadius = 1.cssRem
    val dialogContentIndent = 2.cssRem
    val dialogContentWrapping = 2.cssRem
    val dialogMaxCoverWidth = 60.percent
    val dialogMaxCoverHeight = 80.percent
    val dialogContentGap = 1.cssRem
    val dialogControlsGap = 1.cssRem
    // BUTTONS:
    val buttonHeight = 2.5.cssRem
    val buttonIndent = 1.5.cssRem
    val buttonBorderRadius = 0.5.cssRem
    val buttonFontSize = 1.cssRem
    val buttonBorderWidth = 2 * separatorWidthDefault
    val buttonMinTextSize = 3 * buttonFontSize
    // PAGE:
    val pageIndent = 0.cssRem
    val pageWrapping = 1.cssRem

    val pageHeaderNavIndent = 2.cssRem
    val pageHeaderNavWrapping = 1.5.cssRem
    val pageHeaderNavControlsGap = 1.cssRem
    val pageHeaderSeparatorWidth = 2 * separatorWidthDefault

    val pageOptionsIndent = 0.cssRem
    val pageOptionsWrapping = 1.cssRem
    val pageOptionsSeparatorWidth = 2 * separatorWidthDefault

    val pageHeroTextSize = 2.5.cssRem
    val pageHeaderFontSize = 2.cssRem
    val pageSectionHeaderFontSize = 1.5.cssRem
    val pageSecondaryHeaderFontSize = 1.2.cssRem
    val pageSectionBodyFontSize = 1.1.cssRem
    val pageUnderwritingFontSize = 0.75.cssRem

    val pageBodyUnderwritingGap = 0.1.cssRem

    val pageMainContentIntent = 3.cssRem
    val pageMainContentWrapping = 1.cssRem

    val pageSecondaryLevelIndent = 3.cssRem
    val pageSecondaryLevelWrapping = 3.cssRem

    val pageSectionDefaultGap = 1.5.cssRem
    val pageSectionTitleGap = pageSectionDefaultGap / 2
    // LIST ENTRIES:
    val listEntryIndent = 1.cssRem
    val listEntryWrapping = 1.cssRem
    val listEntryLeftRightSpacer = 2.cssRem
    val listEntryTopDownSpacer = 0.75.cssRem
    val listEntrySeparatorWidth = separatorWidthDefault
    val listEntryImageSize = 9.cssRem
    val listEntryImageBorderWidth = separatorWidthDefault
    val listEntryBackgroundBorderRadius = 1.cssRem
    // CARD ENTRIES:
    val cardEntryIndent = 1.cssRem
    val cardEntryWrapping = 1.cssRem
    val cardEntryTopBottomSpacer = 1.cssRem
    val cardEntryLeftRightSpacer = 2.cssRem
    val cardEntryBorderWidth = 2 * separatorWidthDefault
    val cardEntryBorderRadius = 1.cssRem

    val cardEntriesBaseGap = 1.cssRem
    // DEMO SETS:
    val demoSetCardWidth = 20.cssRem
    val demoSetCardHeight = 14.cssRem
    // QR:
    val qrImageSizeUI = 150.px
    val qrImageSizeLarge = 2 * qrImageSizeUI
    // CHARTS:
    val chartParentHeight = 100.percent
    val chartParentWith = 100.percent
    val chartMinHeight = 400.px
    // INPUTS:
    val inputIndent = 1.cssRem
    val inputWrapping = 1.5.cssRem
    val inputDefaultFontSize = 1.cssRem
    val inputBorderRadius = 0.5.cssRem
    val inputBorderWidth = 2 * separatorWidthDefault
    val inputElementsDefaultGap = 1.cssRem
    // MODE TOGGLE:
    val modeToggleBorderRadius = 0.5.cssRem
    val modeTogglePadding = 0.5.cssRem
    // STEPS WIZARD:
    val stepNumberSize = 2.5.em
    val stepNumberRelFontSize = 1.2.em
    val stepNumberBorderRadius = 50.percent
    // SNACKBAR:
    val snackbarPositionLeft = 50.percent
    val snackbarPositionBottom = 10.percent
    val snackbarIndent = 1.cssRem
    val snackbarWrapping = 0.75.cssRem
    val snackbarBorderRadius = 0.5.cssRem
    val snackbarShadowRadius = 0.5.cssRem
    val snackbarFontSize = 1.cssRem

    // PLAN CONSTRUCTOR
    val planConstructorSeparatorDefault = 2 * separatorWidthDefault

    val planConstructorHeaderIndent = 0.cssRem
    val planConstructorHeaderWrapping = 0.cssRem
    val planConstructorHeaderSeparator = 2 * planConstructorSeparatorDefault

    val planConstructorHeaderElementIndent = 1.cssRem
    val planConstructorHeaderElementWrapping = 1.cssRem
    val planConstructorHeaderElementGap = 0.5.cssRem
    val planConstructorHeaderElementSeparator = 2 * planConstructorSeparatorDefault

    val planConstructorActionButtonMinWidth = 10.cssRem

    val planConstructorSideBarSideSeparator = 2 * planConstructorSeparatorDefault

    val planConstructorSideBarElementIndent = 1.cssRem
    val planConstructorSideBarElementWrapping = 1.cssRem
    val planConstructorSideBarElementsSeparator = planConstructorSeparatorDefault

    val planConstructorSideBarElementMaxHeightDefault = 3.cssRem
    val planConstructorSideBarElementCollectionHeight = planConstructorSideBarElementMaxHeightDefault
    val planConstructorSideBarElementSeriesHeight = 1.5 * planConstructorSideBarElementMaxHeightDefault
    val planConstructorSideBarElementHeaderHeight = 2 * planConstructorSideBarElementMaxHeightDefault
    val planConstructorSideBarElementListMaxWidth = 20.cssRem

    val planConstructorSpawnedElementWrapping = planConstructorSideBarElementWrapping / 2
    val planConstructorGanttChartDaySeparatorWidth = planConstructorSeparatorDefault
    val planConstructorGanttChartDayBoxBorderWidth = 2 * planConstructorSeparatorDefault
    val planConstructorGanttChartDayBoxBorderRadius = 1.cssRem
    val planConstructorGanttChartDayBoxMinWidth = 1.cssRem

    val planConstructorTooltipMinWidth = 11.cssRem
    val planConstructorTooltipMaxWidth = 13.cssRem
    val planConstructorTooltipIndent = 1.cssRem
    val planConstructorTooltipWrapping = 1.cssRem

    val planConstructorTooltipElementsGap = 1.cssRem
    val planConstructorTooltipBorderRadius = 1.cssRem

    val planConstructorSeriesIconPadding = 0.25.em
    val planConstructorSeriesIconBorderRadius = 0.5.em

    val planConstructorContentPadding = 1.cssRem
}
